import React, { useEffect, useState } from 'react';
import { Box, Stack, Step, StepButton, Stepper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';

import {
  PatientsStep,
  ReviewStep,
  SettingsStep,
  UnitsStep,
} from '../components/scenarios';
import { useSimulationsQuery } from '../network/queries';

const STEPS = [
  {
    key: 'pages.scenarios.configure.settings.title',
    Component: SettingsStep,
  },
  {
    key: 'pages.scenarios.configure.units.title',
    Component: UnitsStep,
  },
  {
    id: 'patients',
    key: 'pages.scenarios.configure.patients.title',
    Component: PatientsStep,
  },
  {
    key: 'pages.scenarios.configure.review.title',
    Component: ReviewStep,
  },
];

/**
 * Create or update a scenario.
 * @returns {React.FunctionComponent} React element that contains the page.
 */
function ScenarioFormPage({ editing }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [index, setIndex] = useState(0);
  const { Component } = STEPS[index];

  const onBack = () =>
    setIndex((prev) => {
      return prev <= 0 ? prev : prev - 1;
    });
  const onNext = () =>
    setIndex((prev) => {
      return prev >= STEPS.length - 1 ? prev : prev + 1;
    });

  const { scenarioId } = useParams();
  const { isLoading: isLoadingSimulations, data: simulations } =
    useSimulationsQuery(scenarioId);

  // Prevent users from editing scenarios that have been run
  useEffect(() => {
    if (!isLoadingSimulations && simulations && simulations.length) {
      navigate(`../scenarios/${scenarioId}`);
    }
  }, [isLoadingSimulations, simulations]);

  return (
    !isLoadingSimulations && (
      <Stack spacing={3} sx={{ flex: 1 }}>
        <Stepper activeStep={index} nonLinear={editing}>
          {STEPS.map((i, index) => (
            <Step key={i.id}>
              <StepButton color="inherit" onClick={() => setIndex(index)}>
                {t(i.key)}
              </StepButton>
            </Step>
          ))}
        </Stepper>
        <Box sx={{ flex: 1 }}>
          <Component editing={editing} onBack={onBack} onNext={onNext} />
        </Box>
      </Stack>
    )
  );
}

export default ScenarioFormPage;
